import * as React from 'react'

import { tv, type VariantProps } from 'tailwind-variants'

import { cn } from '@/lib/utils'

export const linkVariants = tv({
  base: 'text-links-fresh-link cursor-pointer underline',
  variants: {
    size: {
      sm: 'text-caption-lg',
      md: 'text-body-md',
      lg: 'text-body-lg',
      xl: 'text-body-xl'
    },
    weight: {
      regular: 'font-normal',
      semibold: 'font-semibold',
      bold: 'font-bold',
      extrabold: 'font-extrabold'
    }
  },
  defaultVariants: {
    size: 'md',
    weight: 'regular'
  }
})

export type TLinkProps<C extends React.ElementType = 'a'> = VariantProps<
  typeof linkVariants
> & {
  href: string
  children: React.ReactNode
  className?: string
  as?: C
} & Omit<
    React.ComponentPropsWithoutRef<C>,
    'as' | 'href' | 'children' | 'className'
  >

export function TVLink<C extends React.ElementType = 'a'>({
  href,
  children,
  size,
  weight,
  className,
  as,
  ...rest
}: TLinkProps<C>): JSX.Element {
  const Component = (as ?? 'a') as React.ElementType
  return (
    <Component
      {...(Component === 'a' ? { href } : {})}
      className={cn(linkVariants({ size, weight }), className)}
      {...(rest as React.ComponentPropsWithoutRef<typeof Component>)}
    >
      {children}
    </Component>
  )
}

export { TVLink as Link }
